export enum SpaMode {
    Hash = 'hash',
    History = 'history',
    Auto = 'auto',
}

export interface AilArmsParams {
    account_id: string
    spaMode?: SpaMode | false;
}